

exports.__esModule = true;

var _addCard = require('./src/add-card');

Object.keys(_addCard).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _addCard[key];
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-wallet-components/index.js
// module id = ./components/xo-wallet-components/index.js
// module chunks = 1